import React from 'react'
import { Form, Input, Select } from 'antd'
import './styles.scss'

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 14 }
  }
}

export default ({ permissions, getFieldDecorator, unit, on_unit_change }) => {

  return (
    <Form className={'united-input'}>
      {permissions.map((permission, index) => (
        <Form.Item {...formItemLayout} label={permission.attribute} key={index}>
          {getFieldDecorator(String(permission.id) + '.' + permission.attribute, {
            rules: [{
              required: true, message: 'Please input your ' + permission.attribute,
            }],
            initialValue: permission.value === -1 ? 'Unlimited' : permission.value
          })(
            <Input
              addonAfter={
                <Select value={unit} defaultValue={1} onChange={on_unit_change}>
                  <Select.Option value={1}>Bytes</Select.Option>
                  <Select.Option value={1024}>KB</Select.Option>
                  <Select.Option value={1048576}>MB</Select.Option>
                  <Select.Option value={1073741824}>GB</Select.Option>
                  <Select.Option value={1099511627776}>TB</Select.Option>
                </Select>
              }/>
          )}
        </Form.Item>
      ))}
    </Form>
  )
}


/*
{/!*<Input />*!/}
const SizeInput = ({ limit, unit, onChange }) => (
  <div className={'united-input'}>
    <input
      type='number' value={limit} style={{ width: '80%' }}
      className='input' name='limit'
      addonAfter={selectAfter}
      onChange={onChange}/>

    <select
      className='input' value={unit} name='unit' style={{ width: '20%' }}
      onChange={onChange}
    >
      <option value='MB'>MB</option>
      <option value='GB'>GB</option>
      <option value='TB'>TB</option>
    </select>
  </div>
)
*/


